var map = {
	"./En/Statics/Contact.js": "./src/pages/En/Statics/Contact.js",
	"./En/Statics/Ethics.js": "./src/pages/En/Statics/Ethics.js",
	"./En/Statics/Faqs/AboutPayRetailers.js": "./src/pages/En/Statics/Faqs/AboutPayRetailers.js",
	"./En/Statics/Faqs/PaymentsReceipts.js": "./src/pages/En/Statics/Faqs/PaymentsReceipts.js",
	"./En/Statics/Faqs/Reembolsos.js": "./src/pages/En/Statics/Faqs/Reembolsos.js",
	"./En/Statics/Faqs/Refunds.js": "./src/pages/En/Statics/Faqs/Refunds.js",
	"./En/Statics/PoliticasBr.js": "./src/pages/En/Statics/PoliticasBr.js",
	"./En/Statics/PrivacyPolicy.js": "./src/pages/En/Statics/PrivacyPolicy.js",
	"./En/Statics/TermsConditions.js": "./src/pages/En/Statics/TermsConditions.js",
	"./En/Statics/TestPage.js": "./src/pages/En/Statics/TestPage.js",
	"./En/Statics/ThankYou.js": "./src/pages/En/Statics/ThankYou.js",
	"./Es/Statics/Contacto.js": "./src/pages/Es/Statics/Contacto.js",
	"./Es/Statics/CustomPage.js": "./src/pages/Es/Statics/CustomPage.js",
	"./Es/Statics/Faqs/AcercaDePayretailers.js": "./src/pages/Es/Statics/Faqs/AcercaDePayretailers.js",
	"./Es/Statics/Faqs/PagosRecibos.js": "./src/pages/Es/Statics/Faqs/PagosRecibos.js",
	"./Es/Statics/Faqs/Reembolsos.js": "./src/pages/Es/Statics/Faqs/Reembolsos.js",
	"./Es/Statics/PoliticasBr.js": "./src/pages/Es/Statics/PoliticasBr.js",
	"./Es/Statics/PoliticasPrivacidad.js": "./src/pages/Es/Statics/PoliticasPrivacidad.js",
	"./Es/Statics/RobertP.js": "./src/pages/Es/Statics/RobertP.js",
	"./Es/Statics/TermsConditions.js": "./src/pages/Es/Statics/TermsConditions.js",
	"./Es/Statics/ThankYou.js": "./src/pages/Es/Statics/ThankYou.js",
	"./Pt/Statics/Contato.js": "./src/pages/Pt/Statics/Contato.js",
	"./Pt/Statics/Faqs/PagamentosRecibos.js": "./src/pages/Pt/Statics/Faqs/PagamentosRecibos.js",
	"./Pt/Statics/Faqs/Reembolsos.js": "./src/pages/Pt/Statics/Faqs/Reembolsos.js",
	"./Pt/Statics/Faqs/SobrePayRetailers.js": "./src/pages/Pt/Statics/Faqs/SobrePayRetailers.js",
	"./Pt/Statics/Ouvidoria.js": "./src/pages/Pt/Statics/Ouvidoria.js",
	"./Pt/Statics/PoliticaPrivacidade.js": "./src/pages/Pt/Statics/PoliticaPrivacidade.js",
	"./Pt/Statics/PoliticasBr.js": "./src/pages/Pt/Statics/PoliticasBr.js",
	"./Pt/Statics/TermsConditions.js": "./src/pages/Pt/Statics/TermsConditions.js",
	"./Pt/Statics/ThankYou.js": "./src/pages/Pt/Statics/ThankYou.js"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/pages lazy recursive ^\\.\\/.*\\/Statics\\/.*\\.js$";
module.exports = webpackAsyncContext;